function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { parse, parseISO } from 'date-fns';
import { AssertionError, assertRequired, fail as assertFail } from '../common/assert';
import ApprovalRequestProgress from '../models/approval-request-progress';
import ApprovalRequestStatus from '../models/approval-request-status';
import Comment from '../models/comment';
import Communication from '../models/communication';
import { CommunicationDisplayStatus } from '../models/communication-display-status';
import { CommunicationRequestType } from '../models/communication-request-type';
import { CommunicationStatus } from '../models/communication-status';
import ContainerKey from '../models/container-key';
import Document from '../models/document';
import DocumentConstraints from '../models/document-constraints';
import Folder from '../models/folder';
import ItemHistory from '../models/item-history';
import ItemLock, { LockLevel, LockType } from '../models/item-lock';
import ItemPage from '../models/item-page';
import { ItemType } from '../models/item-type';
import Link, { LinkType } from '../models/link';
import { LoadingState } from '../models/loading-state';
import LockPermissions from '../models/lock-permissions';
import Page from '../models/page';
import Permissions from '../models/permissions';
import Project from '../models/project';
import RecentItem, { RecentItemVerb } from '../models/recent-item';
import RootFolder, { RootFolderType, subRootKey } from '../models/root-folder';
import Share, { ShareRole, ShareUserType } from '../models/share';
import TreeNode from '../models/tree-node';
import User from '../models/user';
import { DocumentAnnotations } from '../models/document-annotations';
import { DocumentAuditEvents } from '../models/document-audit-events';
import { DocumentAuditEvent } from '../models/document-audit-event';

// Enum mappings are lowercased so spell checker flags them
/* spell-checker: enableCompoundWords */
/* spell-checker: ignore waitingonclient, mytaxandaccountinglibraries */

/**
 * A map of API values to enum values
 *
 * **KEYS MUST BE LOWERCASE**, but this can't be enforced by typescript
 */

var itemTypes = {
  project: ItemType.Project,
  folder: ItemType.Folder,
  client: ItemType.Client,
  document: ItemType.Document,
  template: ItemType.Template,
  // eslint-disable-next-line camelcase
  year_group: ItemType.YearGroup,
  // eslint-disable-next-line camelcase
  app_group: ItemType.AppGroup,
  trash: ItemType.Trash
};
var shareRoles = {
  owner: ShareRole.Owner,
  contributor: ShareRole.Contributor,
  reviewer: ShareRole.Reviewer
};
var shareUserTypes = {
  user: ShareUserType.User,
  group: ShareUserType.Group,
  // eslint-disable-next-line camelcase
  firm_group: ShareUserType.FirmGroup,
  // eslint-disable-next-line camelcase
  onvio_group: ShareUserType.OnvioGroup
};
var linkTypes = {
  genericlink: LinkType.External,
  documentlink: LinkType.Internal,
  checkpointengage: LinkType.CheckpointEngage
};
var lockTypes = {
  none: LockType.None,
  read: LockType.Read,
  edit: LockType.Edit
};
var lockLevels = {
  ancestor: LockLevel.Ancestor,
  descendant: LockLevel.Descendant,
  master: LockLevel.Master
};
var rootFolderTypes = {
  firmtaxandaccountinglibrary: RootFolderType.FirmDocuments,
  mytaxandaccountinglibraries: RootFolderType.MyDocuments,
  general: RootFolderType.General
};
var communicationDisplayStatus = {
  waitingonclient: CommunicationDisplayStatus.WaitingOnClient,
  sent: CommunicationDisplayStatus.Sent,
  completed: CommunicationDisplayStatus.Completed,
  rejected: CommunicationDisplayStatus.Rejected,
  canceled: CommunicationDisplayStatus.Canceled,
  received: CommunicationDisplayStatus.Received
};
var communicationStatus = {
  open: CommunicationStatus.Open,
  closed: CommunicationStatus.Closed,
  rejected: CommunicationStatus.Rejected,
  pastdue: CommunicationStatus.PastDue,
  sent: CommunicationStatus.Sent
};
var communicationRequestType = {
  informational: CommunicationRequestType.Informational,
  approval: CommunicationRequestType.Approval,
  template: CommunicationRequestType.Template,
  send: CommunicationRequestType.Send,
  outlook: CommunicationRequestType.Outlook
};
var recentItemVerbs = {
  accessed: RecentItemVerb.Accessed,
  created: RecentItemVerb.Created,
  updated: RecentItemVerb.Updated,
  moved: RecentItemVerb.Moved,
  copied: RecentItemVerb.Copied,
  restored: RecentItemVerb.Restored,
  linked: RecentItemVerb.Linked,
  trashed: RecentItemVerb.Trashed
};

// Order DOES matter because properties in b will overwrite a
function union(a, b) {
  return Object.assign({}, a, b);
}
function dateOrUndefined(str) {
  return str ? parseISO(str) : undefined;
}

/**
 * Sanitizes and recognizes any of the five main item types.
 * Case and plurality insensitive.
 *
 * @param dto - folder(s), project(s), client(s), document(s), or template(s) - any case
 * @returns ItemType
 */
export function itemType(dto) {
  dto = dto.toLowerCase().replace(/s$/, '');
  if (itemTypes[dto]) {
    return itemTypes[dto];
  }
  throw new AssertionError('Invalid item type', itemTypes, dto);
}
export function item(dto) {
  if (dto.itemType) {
    var type = itemType(dto.itemType);
    if (type === ItemType.Project) {
      return project(dto);
    }
    if (type === ItemType.Folder) {
      return folder(dto);
    }
    if (type === ItemType.Document) {
      if (dto.documentType === 'linkedDoc') {
        return link(dto);
      }
      return document(dto);
    }
  }
  throw new AssertionError('Unknown item type', 'Project, Folder, or Document', dto.itemType, dto);
}
export function itemConstructorArgs(parent, dto) {
  assertRequired(dto.id, 'Item ID', true, dto);
  return {
    id: dto.id,
    name: dto.name,
    parent: parent,
    history: history(dto),
    permissions: permissions(dto.permissions),
    lock: lock(dto.lock),
    legacyItem: dto,
    isShared: false,
    customFields: customFields(dto.customFields),
    customItemMetaData: customItemMetaData(dto.customItemMetaData)
  };
}
export function parentKey(dto) {
  assertRequired(dto.parentItem, 'item.parentItem', true, dto);
  var parent = dto.parentItem;
  assertRequired(parent.id, 'item.parentItem.id', true, dto);
  assertRequired(parent.itemType, 'item.parentItem.itemType', true, dto);
  return new ContainerKey(parent.id, itemType(parent.itemType));
}
export function customFields(dto) {
  return Object.keys(dto !== null && dto !== void 0 ? dto : {}).reduce(function (map, key) {
    map.set(key, dto[key]);
    return map;
  }, new Map());
}
export function customItemMetaData(dto) {
  return Object.keys(dto !== null && dto !== void 0 ? dto : {}).reduce(function (map, key) {
    map.set(key, dto[key]);
    return map;
  }, new Map());
}
export function link(dto) {
  var _dto$url;
  assertRequired((_dto$url = dto.url) !== null && _dto$url !== void 0 ? _dto$url : dto.urlType, 'Link URL or URL Type', true, dto);
  var args = {
    linkType: enumMap(linkTypes, dto.urlType, dto),
    url: dto.url
  };
  var parent = parentKey(dto);
  return new Link(union(itemConstructorArgs(parent, dto), args));
}
export function container(dto) {
  return item(dto);
}
function hasItems(dto) {
  var _dto$hasFolders, _dto$hasFiles;
  return {
    hasFolders: (_dto$hasFolders = dto.hasFolders) !== null && _dto$hasFolders !== void 0 ? _dto$hasFolders : false,
    hasDocuments: (_dto$hasFiles = dto.hasFiles) !== null && _dto$hasFiles !== void 0 ? _dto$hasFiles : false
  };
}

// data is customFields, so it could be anything. Thus, `any`.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function projectApplication(dto) {
  var _dto$scheduleItem;
  return (dto === null || dto === void 0 || (_dto$scheduleItem = dto.scheduleItem) === null || _dto$scheduleItem === void 0 ? void 0 : _dto$scheduleItem.projectApplicationTypeId) || undefined;
}
export function project(dto) {
  var args = _objectSpread({
    isClientUploadFolder: dto.productType === 'ClientContactFolder',
    isShared: dto.isShared,
    isTemplate: dto.primaryAssociationId === 'Templates',
    year: projectYear(dto.processingYear),
    // per Brian, ignore the time component of this date
    dueDate: parseDtoDate(dto.processingPeriod),
    application: projectApplication(dto.customFields),
    numSharedWith: dto.readUserCount - 1
  }, hasItems(dto));
  var parent = new ContainerKey(dto.primaryAssociationId, ItemType.Client);
  return new Project(union(itemConstructorArgs(parent, dto), args));
}

/** Parses the given date string ignoring the time component */
export function parseDtoDate(dtoDateString) {
  if (dtoDateString && dtoDateString.length > 9) {
    dtoDateString = dtoDateString.substring(0, 10);
    return parse(dtoDateString, "yyyy-MM-dd", new Date());
  }
  return undefined;
}
export function projectYear(year) {
  return year && year > 1900 ? year : undefined;
}
export function folder(dto) {
  if (dto.type && dto.rootType && dto.type.toLowerCase() === dto.rootType.toLowerCase()) {
    return rootFolder(dto);
  }
  var args = _objectSpread({
    isShared: dto.isShared
  }, hasItems(dto));
  var parent = parentKey(dto);
  return new Folder(union(itemConstructorArgs(parent, dto), args));
}
export function recentItemVerb(dto) {
  dto = dto.toLowerCase().replace(/s$/, '');
  if (recentItemVerbs[dto]) {
    return recentItemVerbs[dto];
  }
  throw new AssertionError('Invalid recent item verb', recentItemVerbs, dto);
}
export function recentItem(dto) {
  var _dto$name, _dto$mimeType, _dto$itemSize, _dto$isViewable, _dto$name2;
  assertRequired(dto.id, 'id', true);
  assertRequired(dto.verb, 'verb', true);
  assertRequired(dto.activityDate, 'activityDate', true);
  assertRequired(dto.container, 'container', true);
  var container = dto.container;
  assertRequired(container.containerId, 'containerId', true);
  assertRequired(container.containerType, 'containerType', true);
  var parent = new ContainerKey(container.containerId, itemType(container.containerType));
  var documentConstructorArgs = {
    name: (_dto$name = dto.name) !== null && _dto$name !== void 0 ? _dto$name : '',
    mimeType: (_dto$mimeType = dto.mimeType) !== null && _dto$mimeType !== void 0 ? _dto$mimeType : '',
    size: (_dto$itemSize = dto.itemSize) !== null && _dto$itemSize !== void 0 ? _dto$itemSize : -1,
    canPreview: (_dto$isViewable = dto.isViewable) !== null && _dto$isViewable !== void 0 ? _dto$isViewable : false,
    isPasswordProtected: false,
    staffCenterViewPath: ''
  };
  var recentItemAsItem = {
    name: (_dto$name2 = dto.name) !== null && _dto$name2 !== void 0 ? _dto$name2 : '',
    id: dto.id,
    lock: dto.lock
  };
  var parentArgs = union(itemConstructorArgs(parent, recentItemAsItem), documentConstructorArgs);
  return new RecentItem(union(parentArgs, {
    id: dto.id,
    actor: user(dto.actor),
    verb: recentItemVerb(dto.verb),
    activityDate: new Date(dto.activityDate)
  }));
}
export function rootFolder(dto) {
  var args = _objectSpread({
    rootType: enumMap(rootFolderTypes, dto.rootType, dto)
  }, hasItems(dto));
  return new RootFolder(union(itemConstructorArgs(subRootKey, dto), args));
}
function parseFileExtension(name) {
  var loc = name === null || name === void 0 ? void 0 : name.lastIndexOf('.');
  return !loc || loc === -1 ? undefined : name.substring(loc + 1).toLowerCase();
}
export function document(dto) {
  var _dto$mimeType2, _dto$originalItemSize, _dto$isViewable2, _dto$isPasswordProtec, _dto$staffCenterViewP;
  var args = {
    mimeType: (_dto$mimeType2 = dto.mimeType) !== null && _dto$mimeType2 !== void 0 ? _dto$mimeType2 : '',
    size: (_dto$originalItemSize = dto.originalItemSize) !== null && _dto$originalItemSize !== void 0 ? _dto$originalItemSize : -1,
    canPreview: (_dto$isViewable2 = dto.isViewable) !== null && _dto$isViewable2 !== void 0 ? _dto$isViewable2 : false,
    isPasswordProtected: (_dto$isPasswordProtec = dto.isPasswordProtected) !== null && _dto$isPasswordProtec !== void 0 ? _dto$isPasswordProtec : false,
    staffCenterViewPath: (_dto$staffCenterViewP = dto.staffCenterViewPath) !== null && _dto$staffCenterViewP !== void 0 ? _dto$staffCenterViewP : '',
    isReadByClientUser: dto.isReadByClientUser,
    fileExtension: parseFileExtension(dto.name),
    url: dto.url
  };
  var parent = parentKey(dto);
  return new Document(union(itemConstructorArgs(parent, dto), args));
}
export function permissions(dto) {
  var _dto$addContents, _dto$read, _dto$update, _dto$delete, _dto$move;
  if (!dto) {
    return Permissions.none;
  }
  return new Permissions((_dto$addContents = dto.addContents) !== null && _dto$addContents !== void 0 ? _dto$addContents : false, (_dto$read = dto.read) !== null && _dto$read !== void 0 ? _dto$read : false, (_dto$update = dto.update) !== null && _dto$update !== void 0 ? _dto$update : false, (_dto$delete = dto.delete) !== null && _dto$delete !== void 0 ? _dto$delete : false, (_dto$move = dto.move) !== null && _dto$move !== void 0 ? _dto$move : false);
}
export function dateOrNoDate(str) {
  return str ? parseISO(str) : ItemHistory.noDate;
}
export function history(dto) {
  if (!dto) {
    return ItemHistory.none;
  }
  return new ItemHistory(user(dto.createdBy), dateOrNoDate(dto.createdDate), user(dto.modifiedBy), dateOrNoDate(dto.modifiedDate));
}
export function name(dto) {
  var comma = dto.indexOf(',');
  var space = dto.indexOf(' ');
  if (comma !== -1) {
    var first = dto.substring(comma + 1).trim();
    var last = dto.substring(0, comma);
    return [first, last];
  }
  if (space !== -1) {
    var _first = dto.substring(0, space);
    var _last = dto.substring(space + 1);
    return [_first, _last];
  }
  return ['', dto];
}
export function userFromString(dto) {
  if (!dto) {
    return User.none;
  }
  var _name = name(dto),
    _name2 = _slicedToArray(_name, 2),
    first = _name2[0],
    last = _name2[1];
  if (first) {
    return new User(User.none.id, false, first, last, dto);
  }
  return new User(last, false);
}
export function user(dto) {
  var _dto$isCurrentUser;
  if (!dto) {
    return User.none;
  }
  assertRequired(dto.userGuid, 'User GUID', false, dto);
  return new User(dto.userGuid, (_dto$isCurrentUser = dto.isCurrentUser) !== null && _dto$isCurrentUser !== void 0 ? _dto$isCurrentUser : false, dto.firstName, dto.lastName, dto.displayAs);
}

/**
 * Returns the ItemPage of the given IPaginatedResult DTO.
 *
 * @param dto - IPaginatedResult of an Item
 * @param itemCallbackFn - Function that is called when mapping the items array. Can be called with item or recentItem.
 * @returns ItemPage<Item>
 */
export function itemPage(dto, itemCallbackFn) {
  return new ItemPage(dto.items ? dto.items.map(itemCallbackFn) : [], page(dto), dto.totalItems, dto.totalPages, dto.hasMore);
}
export function page(dto) {
  var _dto$startIndex, _dto$itemsPerPage;
  return Page.fromStartIndex((_dto$startIndex = dto.startIndex) !== null && _dto$startIndex !== void 0 ? _dto$startIndex : 0, (_dto$itemsPerPage = dto.itemsPerPage) !== null && _dto$itemsPerPage !== void 0 ? _dto$itemsPerPage : 0);
}
export function pageFromPageNumber(dto) {
  var _dto$pageIndex, _dto$itemsPerPage2;
  return Page.fromPageNumber((_dto$pageIndex = dto.pageIndex) !== null && _dto$pageIndex !== void 0 ? _dto$pageIndex : 0, (_dto$itemsPerPage2 = dto.itemsPerPage) !== null && _dto$itemsPerPage2 !== void 0 ? _dto$itemsPerPage2 : 0);
}
export function pairsToMap(dto) {
  if (dto) {
    // According to the dto, neither key nor value are required?!?!
    // First, drop all un-keyed pairs
    var tuples = dto.filter(function (pair) {
      return pair.key;
    })
    // Default values to empty object I guess
    .map(function (pair) {
      var _pair$value;
      return [pair.key, (_pair$value = pair.value) !== null && _pair$value !== void 0 ? _pair$value : {}];
    });
    return new Map(tuples);
  }
  return new Map();
}
export function date(dto) {
  return dto ? new Date(dto) : ItemHistory.noDate;
}
function has(array, value) {
  return !!(array !== null && array !== void 0 && array.includes(value));
}
export function lockPermissions(dto) {
  return new LockPermissions(
  // 'create' is moot, this is already created.
  false,
  // If we couldn't read this file, we wouldn't be here.
  true, !has(dto, 'UPDATE'), !has(dto, 'DELETE'), !has(dto, 'MOVE'), !has(dto, 'COMMENTS'), !has(dto, 'CREATE_MASTER_LOCK'), !has(dto, 'CREATE_SUB_RESOURCE'));
}
export function lock(dto) {
  if (!dto) {
    return;
  }
  return new ItemLock(enumMap(lockTypes, dto.type, dto), enumMap(lockLevels, dto.level, dto), lockPermissions(dto.resourceRestrictions), userFromString(dto.createdBy), dto.createdDate ? new Date(dto.createdDate) : ItemHistory.noDate, new Map(),
  // PairsToMap(dto.contextInfo),
  dto.context);
}
export function comment(dto) {
  var _dto$created, _dto$changed, _dto$notedata, _dto$isdeleted, _dto$deleted;
  // API gives back some strangely cased properties here
  /* spell-checker: disable */

  var noteUser = new User(dto.createdbyid || User.none.id, false, dto.createdbyGivenName, dto.createdbyFamilyName);
  var noteHistory = new ItemHistory(noteUser, (_dto$created = dto.created) !== null && _dto$created !== void 0 ? _dto$created : ItemHistory.noDate, User.none, (_dto$changed = dto.changed) !== null && _dto$changed !== void 0 ? _dto$changed : ItemHistory.noDate);
  return new Comment(dto.id, dto.entityid, (_dto$notedata = dto.notedata) !== null && _dto$notedata !== void 0 ? _dto$notedata : '', noteHistory, (_dto$isdeleted = dto.isdeleted) !== null && _dto$isdeleted !== void 0 ? _dto$isdeleted : false, (_dto$deleted = dto.deleted) !== null && _dto$deleted !== void 0 ? _dto$deleted : ItemHistory.noDate);

  /* spell-checker: enable */
}
export function approvalRequestStatus(dto) {
  var _dto$numSubRequestsOp, _dto$numSubRequestsCl, _dto$numSubRequestsRe;
  return new ApprovalRequestStatus((_dto$numSubRequestsOp = dto.numSubRequestsOpen) !== null && _dto$numSubRequestsOp !== void 0 ? _dto$numSubRequestsOp : 0, (_dto$numSubRequestsCl = dto.numSubRequestsClosed) !== null && _dto$numSubRequestsCl !== void 0 ? _dto$numSubRequestsCl : 0, (_dto$numSubRequestsRe = dto.numSubRequestsRejected) !== null && _dto$numSubRequestsRe !== void 0 ? _dto$numSubRequestsRe : 0);
}
export function documentConstraints(dto) {
  var documentConstraintsArgs = {
    maxUploadSize: dto.maxUploadSize,
    minUploadSize: dto.minUploadSize,
    maxFileNameSize: dto.maxFileNameSize,
    minFileNameSize: dto.minFileNameSize,
    maxFolderNameSize: dto.maxFolderNameSize,
    minFolderNameSize: dto.minFolderNameSize,
    maxConvertedSize: dto.maxConvertedSize,
    unconvertedTypes: dto.unconvertedTypes,
    convertedTypes: dto.convertedTypes
  };
  return new DocumentConstraints(documentConstraintsArgs);
}
export function treeNode(dto) {
  var _dto$subContainers$ma, _dto$subContainers;
  var children = (_dto$subContainers$ma = (_dto$subContainers = dto.subContainers) === null || _dto$subContainers === void 0 ? void 0 : _dto$subContainers.map(treeNode)) !== null && _dto$subContainers$ma !== void 0 ? _dto$subContainers$ma : [];
  return new TreeNode(item(dto), children, LoadingState.loaded);
}
export function share(dto) {
  assertRequired(dto.memberId, 'ContainerPermission memberId', true, dto);
  assertRequired(dto.role, 'ContainerPermission role', true, dto);
  var shareUser = new User(dto.memberId, false, dto.memberFirstName, dto.memberLastName, dto.memberDisplayAs);
  var role = enumMap(shareRoles, dto.role, dto);
  var type = enumMap(shareUserTypes, dto.memberType, dto);
  return new Share(shareUser, role, type);
}
export function createdByUserFromRequest(dto) {
  if (!dto.createdBy) {
    return User.none;
  }
  assertRequired(dto.id, 'User GUID', false, dto);
  return new User(dto.createdBy.id, true, dto.createdBy.name);
}
export function changedByUserFromRequest(dto) {
  if (!dto.changedBy) {
    return User.none;
  }
  assertRequired(dto.id, 'User GUID', false, dto);
  return new User(dto.changedBy.id, true, dto.changedBy.name);
}
export function containerKey(id, containerType) {
  assertRequired(id, 'containerId', true);
  assertRequired(containerType, 'containerType', true);
  return new ContainerKey(id, itemType(containerType));
}
export function communicationSubRequest(dto) {
  var _dto$documents, _dto$recipients;
  assertRequired(dto.id, 'subRequestDto id', true, dto);
  assertRequired(dto.requestId, 'subRequestDto requestId', true, dto);
  assertRequired(dto.type, 'subRequestDto type', true, dto);
  assertRequired(dto.containerType, 'subRequestDto containerType', true, dto);
  assertRequired(dto.documents, 'subRequestDto documents', true, dto);
  var communicationsSubRequest = {
    id: dto.id,
    requestId: dto.requestId,
    type: dto.type,
    details: dto.details,
    communicationStatus: toCommunicationStatus(dto.communicationStatus, dto.status, dto),
    status: dto.status && enumMap(communicationStatus, dto.status, dto),
    comments: dto.comments,
    containerKey: containerKey(dto.containerId, dto.containerType),
    changedDate: dateOrUndefined(dto.changedDate),
    documents: ((_dto$documents = dto.documents) !== null && _dto$documents !== void 0 ? _dto$documents : []).map(function (requestDocument) {
      return communicationDocumentFromRequestDocument(requestDocument);
    }),
    recipients: (_dto$recipients = dto.recipients) === null || _dto$recipients === void 0 ? void 0 : _dto$recipients.map(function (recipient) {
      return communicationRequestRecipient(recipient);
    })
  };
  return communicationsSubRequest;
}
function toCommunicationStatus(dtoCommunicationStatus, status, context) {
  return dtoCommunicationStatus && enumMap(communicationDisplayStatus, dtoCommunicationStatus, context) || status && upgradeRequestStatus(status) || CommunicationDisplayStatus.WaitingOnClient;
}
function upgradeRequestStatus(status) {
  if (status === 'Closed' || status === 'Rejected') {
    return CommunicationDisplayStatus.Completed;
  }
  if (status === 'PastDue') {
    return CommunicationDisplayStatus.Canceled;
  }
  return CommunicationDisplayStatus.WaitingOnClient;
}
export function communicationDocumentFromRequestDocument(documentDto) {
  assertRequired(documentDto.subRequestId, 'documentDto subRequestId', true, documentDto);
  assertRequired(documentDto.documentId, 'documentDto documentId', true, documentDto);
  assertRequired(documentDto.changedDate, 'documentDto changedDate', true, documentDto);
  var communicationRequestDocument = {
    subRequestId: documentDto.subRequestId,
    documentId: documentDto.documentId,
    mimeType: documentDto.mimeType,
    changedDate: dateOrUndefined(documentDto.changedDate),
    outlookLink: documentDto.outlookLink
  };
  return communicationRequestDocument;
}
export function communicationRequestRecipient(requestRecipientDto) {
  assertRequired(requestRecipientDto.id, 'requestRecipientDto Id', true, requestRecipientDto);
  assertRequired(requestRecipientDto.changedDate, 'requestRecipientDto changedDate', true, requestRecipientDto);
  var communicationRecipient = {
    id: requestRecipientDto.id,
    requestId: requestRecipientDto.requestId,
    contactId: requestRecipientDto.contactId,
    name: requestRecipientDto.name,
    emailAddress: requestRecipientDto.emailAddress,
    changedDate: dateOrUndefined(requestRecipientDto.changedDate),
    culture: requestRecipientDto.culture
  };
  return communicationRecipient;
}
export function approvalProgress(dto) {
  assertRequired(dto.id, 'approvalRequestProgress.requestId', true, dto);
  var progress = dto.approvalProgress;
  if (dto.requestType === CommunicationRequestType.Approval) {
    return new ApprovalRequestProgress(dto.id, progress.numSubRequestsOpen, progress.numSubRequestsClosed, progress.numSubRequestsRejected);
  }
  return new ApprovalRequestProgress(dto.id);
}
export function communication(dto) {
  assertRequired(dto.id, 'Communications Id', true, dto);
  assertRequired(dto.createdDate, 'Communications createdDate', true, dto);
  assertRequired(dto.subject, 'Communications subject', true, dto);
  assertRequired(dto.dueDate, 'Communications dueDate', true, dto);
  assertRequired(dto.requestType, 'Communications requestType', true, dto);
  assertRequired(dto.subRequests, 'Communications subRequests', true, dto);
  assertRequired(dto.recipients, 'Communications recipients', true, dto);
  assertRequired(dto.companyId, 'Communications companyId', true, dto);
  var communicationsArgs = {
    id: dto.id,
    createdDate: parseISO(dto.createdDate),
    createdBy: createdByUserFromRequest(dto),
    subject: dto.subject,
    dueDate: parseISO(dto.dueDate),
    reminderDate: dateOrUndefined(dto.reminderDate),
    expirationDate: dateOrUndefined(dto.expirationDate),
    isViewed: dto.isViewed,
    comments: dto.comments,
    status: dto.status && enumMap(communicationStatus, dto.status, dto),
    communicationStatus: toCommunicationStatus(dto.communicationStatus, dto.status),
    requestType: enumMap(communicationRequestType, dto.requestType, dto),
    companyId: dto.companyId,
    clientId: dto.clientId,
    clientName: dto.clientName,
    projectId: dto.projectId,
    sendDate: dateOrUndefined(dto.sendDate),
    approvedDate: dateOrUndefined(dto.approvedDate),
    changedDate: dateOrUndefined(dto.changedDate),
    subRequests: dto.subRequests.map(function (subRequest) {
      return communicationSubRequest(subRequest);
    }),
    recipients: dto.recipients.map(function (recipient) {
      return communicationRequestRecipient(recipient);
    }),
    progress: dto.progress,
    approvalProgress: dto.approvalProgress && approvalProgress(dto),
    changedBy: changedByUserFromRequest(dto),
    metaData: dto.metadata
  };
  return new Communication(communicationsArgs);
}
export function paginatedCommunication(dto) {
  return new ItemPage(dto.items ? dto.items.map(communication) : [], pageFromPageNumber(dto), dto.totalItems, dto.totalPages);
}
export function annotations(dto) {
  return new DocumentAnnotations(dto.annotations);
}
export function documentAuditEvents(dto) {
  var _dto$hasMore;
  var documentAuditEvents = dto.items.map(function (item) {
    return new DocumentAuditEvent(item.companyId, item.noun, item.verb, item.subjectContactId, item.contactDisplayName, new Date(item.eventTimestamp), item.metadata, item.clientId, item.documentName);
  });
  var dtoHasMore = (_dto$hasMore = dto.hasMore) !== null && _dto$hasMore !== void 0 ? _dto$hasMore : false;
  return new DocumentAuditEvents(documentAuditEvents, dtoHasMore);
}

/**
 * Does case-insensitive mapping of enum values from backend to frontend
 *
 * @param lookup - map of **lowercase** keys to enum values
 * @param apiValue - enum value
 * @param context - context
 */
function enumMap(lookup, apiValue, context) {
  var _apiValue;
  apiValue = (_apiValue = apiValue) === null || _apiValue === void 0 ? void 0 : _apiValue.toLowerCase();
  if (apiValue && Object.prototype.hasOwnProperty.call(lookup, apiValue)) {
    return lookup[apiValue];
  }
  if (apiValue) {
    assertFail('Invalid enum value', lookup, apiValue, false, context);
  }
  return apiValue;
}
